import {
	alpha,
	ToggleButton,
	ToggleButtonGroup,
	type Theme,
} from "@mui/material";

const selectedSx = (color: "success" | "error") => (theme: Theme) => ({
	// Exclude disabled buttons so loading/non-applicable checks retain MUI's muted state.
	"&.Mui-selected:not(.Mui-disabled)": {
		backgroundColor: alpha(theme.palette[color].main, 0.12),
		color: theme.palette[color].main,
		fontWeight: 700,
		"&:hover": {
			backgroundColor: alpha(theme.palette[color].main, 0.2),
		},
	},
	"&.Mui-focusVisible": {
		outline: `2px solid ${theme.palette.text.primary}`,
		outlineOffset: 2,
		zIndex: 1,
	},
});

interface InspectionCheckToggleProps {
	label: string;
	variant?: "go-no-go" | "yes-no";
	value: boolean | null;
	disabled: boolean;
	onChange: (value: boolean | null) => void;
	onBlur?: () => void;
}

export const InspectionCheckToggle = ({
	label,
	variant = "go-no-go",
	value,
	disabled,
	onChange,
	onBlur,
}: InspectionCheckToggleProps) => (
	<ToggleButtonGroup
		exclusive
		size="small"
		aria-label={label}
		value={value}
		disabled={disabled}
		onBlur={onBlur}
		onChange={(_, selected: boolean | null) => onChange(selected)}
		sx={{
			"& .MuiToggleButton-root": {
				minWidth: 27,
				px: 0.5,
				py: 0,
				height: 26,
				fontSize: "0.75rem",
				lineHeight: 1,
			},
		}}
	>
		<ToggleButton value={true} color="success" sx={selectedSx("success")}>
			{variant === "yes-no" ? "Yes" : "GO"}
		</ToggleButton>
		<ToggleButton value={false} color="error" sx={selectedSx("error")}>
			{variant === "yes-no" ? "No" : "NG"}
		</ToggleButton>
	</ToggleButtonGroup>
);
